import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complete-payment',
  templateUrl: './complete-payment.component.html',
  styleUrls: ['./complete-payment.component.css']
})
export class CompletePaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
